import type { SkuComponentConfigMap } from '@/types/enums/sku-component-types'
import ClinicianWidgetImage from '@/assets/images/refresh/clinitian-hiring/why.jpg'
import MedicationImg from '@/assets/images/refresh/support_widget/medication.webp'
import LabsImg from '@/assets/images/refresh/support_widget/labs.webp'
import DermatologyImg from '@/assets/images/refresh/support_widget/dermatology.webp'
import TravelImg from '@/assets/images/refresh/support_widget/travel.webp'
import EverydayImg from '@/assets/images/refresh/support_widget/everyday.webp'

// Generic, non-drug-specific copy shared by every medication PDP — there's no PDP data
// field for per-drug "ongoing support" or "explore more care" content, so these sections
// use the same platform-wide copy everywhere rather than fabricating per-drug claims.

export const PDP_CLINICIAN_WIDGET_CONFIG: SkuComponentConfigMap['skuClinicianWidget'] = {
    type: 'skuClinicianWidget',
    title: 'Ongoing support, always available.',
    bodyHtml:
        '<p>Your care doesn’t end after your visit. Message your care team anytime to discuss side effects, ask questions about your medication, or request a refill.</p><p>We stay proactive so your care stays steady — adjusting your plan as needed and keeping you informed every step of the way.</p>',
    imageSrc: ClinicianWidgetImage,
    imageAlt: 'Virtual visit with clinician',
}

export const PDP_SUPPORT_WIDGET_CONFIG: SkuComponentConfigMap['skuSupportWidget'] = {
    type: 'skuSupportWidget',
    title: 'Dive deeper: get the support you need',
    bodyHtml:
        '<p>Your health rarely comes down to just one thing. If your clinician identifies related needs during your visit, we can help address them through additional services.</p>',
    cards: [
        {
            title: 'Medications',
            description: 'We will write your prescription and send it to your pharmacy',
            href: '/store/medications',
            imageSrc: MedicationImg,
        },
        {
            title: 'Lab tests',
            description: 'See cost up front and book your lab test instantly',
            href: '/store/labs',
            imageSrc: LabsImg,
        },
        {
            title: 'Dermatology',
            description: 'Get a specialist consult or talk to a clinician about your condition',
            href: '/store/dermatology',
            imageSrc: DermatologyImg,
        },
        {
            title: 'Travel needs',
            description: 'Going on a big trip? Get the vaccines and medications you need',
            href: '/s/travel-medicine-vaccination-counseling/400012',
            imageSrc: TravelImg,
        },
        {
            title: 'Everyday care',
            description: 'No waitlist, rushed visits, or hidden fees—get care fast.',
            href: '/store/everyday-care',
            imageSrc: EverydayImg,
        },
    ],
}
